import React from "react";
import CalendarHeatmap from "react-calendar-heatmap";

function convertdataformat(data) {
  if (!data) {
    return;
  }
  for (var i = 0; i < data.length; i++) {
    data[i]["count"] = Math.min(4, Math.floor(data[i]["dayminutes"] / 40) + 1);
  }
  return data;
}

const Calendar = (props) => {
  const data = convertdataformat(props.data);
  const year = props.year || new Date().getFullYear();

  return (
    <div className="heatmap">
      <CalendarHeatmap
        startDate={new Date(year + "-01-01")}
        endDate={new Date(year + "-12-31")}
        values={data}
        showOutOfRangeDays
        gutterSize={1.5}
        classForValue={(value) => {
          if (!value) {
            return "color-empty";
          }
          return `color-github-${value.count}`;
        }}
        weekdayLabels={["Su ", "Mo ", "Tu ", "We ", "Th ", "Fr ", "Sa "]}
        tooltipDataAttrs={(value) => {
          return {
            "data-tooltip": ` has count: ${value.count}`,
          };
        }}
        showWeekdayLabels={true}
      />
    </div>
  );
};

export default Calendar;
